<template>
    <div>
        <ul>
            <li v-for="(m,i) in data" :key="i">
                <div :class="m.is_get === true?'item itemdis':'item couponget'" @click="getCoupon(m.id, i)">
                    <div class="amt">{{ m.amt }}<span>FXB</span></div>
                    <div class="name">{{ m.name }}</div>
                    <div class="time">剩余 /&nbsp;&nbsp;{{ m.surplus }}张</div>
                    <div class="tag" v-if="m.is_get">已领取</div>
                    <div class="tag" v-else>立即抢券</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "coupon",
    props: ['data'],
    components: {
    },
    watch: {

    },
    data(){
        return {

        }
    },
    methods: {
        getCoupon(id, index){
            let that = this, item = that.data[index]
            if(item.is_get) return
            that.$post(that.$api.getCoupon, {cid: id}).then(function (res) {
                if(res.code === 1){
                    that.$toast.success(res.msg)
                }
                else if(res.code === 2){
                    that.$toast.fail(res.msg)
                    item.is_get = true
                }
                else
                    that.$toast.fail(res.msg)
            })
        }
    }
}
</script>

<style scoped>
</style>
